

import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { API_URL, BITRIX_URL, BITRIX_USERNAME, BITRIX_PASSWORD } from "../../resources/api.config";

const baseUrl = API_URL;
const bitrixUrl = BITRIX_URL;

const logs = false;

let isHandlingUnauthorized = false;
let isShowingAuthAlert = false;

let storeInstance: any = null;

const getStore = () => {
  if (!storeInstance) {
    storeInstance = require("../../redux/store").default;
  }
  return storeInstance;
};
const handleUnauthorized = () => {
  if (isHandlingUnauthorized) return;
  isHandlingUnauthorized = true;

  try {
    const store = getStore();
    const dispatch = store.dispatch;
    
    const { clearAuthData } = require("../../redux/auth/slice");
    const { clearUser } = require("../../redux/user/slice");
    const { clearBasket } = require("../../redux/cart/slice");
    
    dispatch(clearAuthData());
    dispatch(clearUser());
    dispatch(clearBasket());
    window.location.href = '/profile/settings';
    
  } finally {
    setTimeout(() => {
      isHandlingUnauthorized = false;
    }, 500);
  }
};

const showAuthRequiredModal = () => {
  if (isShowingAuthAlert) return;
  isShowingAuthAlert = true;

  const userConfirmed = window.confirm(
    'Требуется авторизация\n\nАвторизуйтесь для доступа к полному функционалу приложения'
  );

  setTimeout(() => {
    isShowingAuthAlert = false;
    if (!userConfirmed) {
      handleUnauthorized();
    } else {
      handleUnauthorized();
    }
  }, 100);
};


export const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    const store = getStore();
    const state = store.getState();
    const token = (state as any).auth?.accessToken;

    if (token) {
      config.headers = config.headers || {};
      (config.headers as any)['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {

    try {
      const status = error?.response?.status;
      if (status === 401) {
        const store = getStore();
        const state = store.getState();
        const hasToken = !!(state as any).auth?.accessToken; 
        if (hasToken) {
          handleUnauthorized();
        }
      }
    } catch (_) {
    }

    return Promise.reject(error);
  }
);


export const axiosBitrixInstance = axios.create({
  baseURL: bitrixUrl,
});

axiosBitrixInstance.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    const store = getStore();
    const state = store.getState();
    const partnerId = (state as any).user?.partnerId;

    const isException = (url: string | undefined): boolean => {
      if (!url) return true;

      let decodedUrl = url;
      try {
        decodedUrl = decodeURIComponent(url);
      } catch (e) {
        decodedUrl = url;
      }

      const exceptionPatterns = ['/ActiveMemberships', '/DailySchedule', '/ActiveCourts', '/partner/lookup'];

      for (const pattern of exceptionPatterns) {
        if (decodedUrl.startsWith(pattern) || url.startsWith(pattern)) {
          return false;
        }
      }

      return true;
    };

    const isRegistrationRequest = (config as any).skipPartnerIdCheck === true;

    if (!partnerId && !isRegistrationRequest && isException(config.url)) {
      if (!isShowingAuthAlert) {
        showAuthRequiredModal();
      }

      return Promise.reject(new Error('Missing partner_id'));
    }

    config.auth = {
      username: BITRIX_USERNAME,
      password: BITRIX_PASSWORD,
    };

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosBitrixInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

